import store from '@/store'
import { mainBeforeEnter } from '@/common/util/common'
import {
  PATH_NAME_COIN,
  PATH_NAME_COUPON,
  PATH_NAME_LIKE_CHANNEL,
  PATH_NAME_LIKE_MOVIE,
  PATH_NAME_LIKE_PROGRAM,
  PATH_NAME_LIKE_THEME,
  PATH_NAME_LIST,
  PATH_NAME_MY,
  PATH_NAME_PLAYER,
  PATH_NAME_POPUP_CHANGE_PAYMENT,
  PATH_NAME_RESERVE_WATCH,
  PATH_NAME_REVOCATION_DEFENCE,
  PATH_NAME_SEARCH,
  PATH_NAME_SUBSCRIPTION_CANCEL,
  PATH_NAME_SUBSCRIPTION_TICKET,
  PATH_NAME_USE_LIST_MOVIE_HISTORY,
  PATH_NAME_USE_LIST_VOD_HISTORY,
  PATH_NAME_VOUCHER_INDEX,
  PATH_NAME_VOUCHER_LIST_PACKAGE,
  PATH_NAME_VOUCHER_LIST_SINGULAR,
  PATH_NAME_DEVICE_HISTORY,
} from '@/common/router.const'

export default [
  {
    path: '/my',
    components: {
      mypooq: () =>
        import(/* webpackChunkName: "myPooq" */ `@/views/mypooq/MyPooqView`),
    },
    beforeEnter(to, from, next) {
      const fromNameList = [
        PATH_NAME_SEARCH,
        PATH_NAME_SUBSCRIPTION_CANCEL,
        PATH_NAME_POPUP_CHANGE_PAYMENT,
        PATH_NAME_REVOCATION_DEFENCE,
      ]
      if (from.query.adult !== 'y' && fromNameList.indexOf(from.name) === -1) {
        const pathList = to.fullPath.split('/')
        const nameList = [PATH_NAME_LIST, PATH_NAME_VOUCHER_INDEX]
        const isLivePlayer =
          from.name === PATH_NAME_PLAYER && from.params.section === 'live'
        if (
          (to.name === 'my' ||
            (nameList.indexOf(from.name) > -1 && pathList[1] === 'my')) &&
          !isLivePlayer
        ) {
          store.commit('setBeforePathOpenMyPooq', '/my')
        } else {
          store.commit('setBeforePathOpenMyPooq', from.fullPath)
        }
      } else if (
        from.fullPath.indexOf('?') > -1 &&
        from.name !== PATH_NAME_POPUP_CHANGE_PAYMENT &&
        from.name !== PATH_NAME_SUBSCRIPTION_CANCEL
      ) {
        store.commit('setBeforePathOpenMyPooq', '/' + from.params.section || '')
      }
      document.body.classList.add('mypooq-body')
      next()
    },
    beforeRouteLeave() {
      document.body.classList.remove('mypooq-body')
    },
    children: [
      // 이용내역
      {
        path: '',
        name: PATH_NAME_MY,
        meta: { menu: '', title: '' },
        alias: 'index.html',
        components: {
          my: () => import('@/components/lnb/mypooq/index'),
        },
        beforeEnter: mainBeforeEnter,
      },
      {
        path: 'use_list_vod_history',
        name: PATH_NAME_USE_LIST_VOD_HISTORY,
        meta: { menu: 'history', title: '시청내역' },
        alias: 'use_list_vod_history.html',
        components: {
          use_list_vod_history: () =>
            import('@/components/lnb/mypooq/MyPooqUseListHistoryVod'),
        },
      },
      {
        path: 'use_list_movie_history',
        name: PATH_NAME_USE_LIST_MOVIE_HISTORY,
        meta: { menu: 'history', title: '시청내역' },
        alias: 'use_list_movie_history.html',
        components: {
          use_list_movie_history: () =>
            import('@/components/lnb/mypooq/MyPooqUseListHistoryMovie'),
        },
      },
      {
        path: 'like_program',
        name: PATH_NAME_LIKE_PROGRAM,
        meta: { menu: '', title: '관심 프로그램' },
        alias: 'like_program.html',
        components: {
          like_program: () =>
            import('@/components/lnb/mypooq/MyPooqLikeProgram'),
        },
      },
      {
        path: 'like_movie',
        name: PATH_NAME_LIKE_MOVIE,
        meta: { menu: '', title: '관심 영화' },
        alias: 'like_movie.html',
        components: {
          like_movie: () => import('@/components/lnb/mypooq/MyPooqLikeMovie'),
        },
      },
      {
        path: 'like_channel',
        name: PATH_NAME_LIKE_CHANNEL,
        meta: { menu: '', title: '관심 채널' },
        alias: 'like_channel.html',
        components: {
          like_channel: () =>
            import('@/components/lnb/mypooq/MyPooqLikeChannel'),
        },
      },
      {
        path: 'like_theme',
        name: PATH_NAME_LIKE_THEME,
        meta: { menu: '', title: '관심 에디터Pick' },
        alias: 'like_theme.html',
        components: {
          like_theme: () => import('@/components/lnb/mypooq/MyPooqLikeTheme'),
        },
      },
      {
        path: 'reserve_watch',
        name: PATH_NAME_RESERVE_WATCH,
        meta: { menu: '', title: '시청 예약' },
        alias: 'reserve_watch.html',
        components: {
          reserve_watch: () => import('@/components/lnb/mypooq/MyPooqAlarm'),
        },
      },
      {
        // 구매 콘텐츠 단건
        path: 'voucher_list_singular',
        name: PATH_NAME_VOUCHER_LIST_SINGULAR,
        meta: { menu: 'voucher', title: '구매콘텐츠' },
        alias: 'voucher_list_singular.html',
        components: {
          voucher_list_singular: () =>
            import('@/components/lnb/mypooq/MyPooqVoucherListSingular'),
        },
      },
      {
        // 구매 콘텐츠 패키지
        path: 'voucher_list_package',
        name: PATH_NAME_VOUCHER_LIST_PACKAGE,
        meta: { menu: 'voucher', title: '구매콘텐츠' },
        alias: 'voucher_list_package.html',
        components: {
          voucher_list_package: () =>
            import('@/components/lnb/mypooq/MyPooqVoucherListPackage'),
        },
      },
      {
        // 이용권 내역
        path: 'subscription_ticket',
        name: PATH_NAME_SUBSCRIPTION_TICKET,
        meta: { menu: '', title: '이용권내역' },
        alias: 'subscription_ticket.html',
        components: {
          subscription_ticket: () =>
            import('@/components/lnb/mypooq/MyPooqSubscriptionTicket'),
        },
      },
      {
        path: 'coin',
        name: PATH_NAME_COIN,
        meta: { menu: 'coin_coupon', title: '코인내역' },
        alias: 'coin.html',
        components: {
          coin: () => import('@/components/lnb/mypooq/Coin'),
        },
      },
      {
        path: 'coupon',
        name: PATH_NAME_COUPON,
        meta: { menu: 'coin_coupon', title: '쿠폰내역' },
        alias: 'coupon.html',
        components: {
          coupon: () => import('@/components/lnb/mypooq/Coupon'),
        },
      },
      {
        path: 'device-history',
        name: PATH_NAME_DEVICE_HISTORY,
        meta: { menu: '', title: '디바이스 관리', closeBtn: true },
        alias: 'device-history.html',
        components: {
          deviceHistory: () => import('@/components/lnb/mypooq/DeviceHistory'),
        },
      },
    ],
  },
  // TODO: my로 변경 예정 변경 후 redirect 테스트
  {
    path: '/my/subscription_ticket/cancel',
    name: PATH_NAME_SUBSCRIPTION_CANCEL,
    components: {
      cancelPopup: () =>
        import('@/components/lnb/mypooq/popup/PopupRevocationDefense'),
    },
  },
]
